<template>
  <div>
    <!-- if the review is loading -->
    <div v-if="reviewLoading">
      <v-row class="text-center mx-auto">
        <v-col class="mb-4" cols="12">
          <v-col
            cols="12"
            style="height: 50vh"
            class="d-flex justify-center align-center"
          >
            <v-progress-circular
              :size="50"
              class="m"
              indeterminate
              color="primary"
            >
            </v-progress-circular>
          </v-col>
        </v-col>
      </v-row>
    </div>
    <div v-if="!reviewLoading">
      <!-- if there was an error loading the review -->
      <div v-if="reviewLoadingError">
        <v-col cols="12" class="d-flex justify-center align-center mb-5 mt-5">
          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center align-center ma-0 pa-0"
            >
              <v-icon x-large color="red darken-2">
                mdi-information-slab-circle-outline
              </v-icon>
            </v-col>
            <v-col
              cols="12"
              class="d-flex justify-center align-center ma-0 pa-0"
            >
              {{ reviewLoadingError }}
            </v-col>
          </v-row>
        </v-col>
      </div>
      <!-- all ok - show review card -->
      <div v-if="!reviewLoadingError">
        <v-card>
          <v-app-bar flat color="rgba(0, 0, 0, 0)">
            <v-toolbar-title class="text-h6 pl-0 mb-2">
              Review resume
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip
              small
              :color="this.$consts.TIER_MAP.get(review.Tier).color"
              text-color="white"
            >
              {{ this.$consts.TIER_MAP.get(review.Tier).name, }}
            </v-chip>
            <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="() => {}">
                  <v-list-item-icon>
                    <v-icon>mdi-alert-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Report a problem</v-list-item-title>
                </v-list-item>
                <v-list-item @click="abandonReview()">
                  <v-list-item-icon>
                    <v-icon>mdi-close</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Unassign review</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-app-bar>
          <v-card-text class="mt-1 pt-1">
            <v-row>
              <v-col cols="12" md="9" class="mt-1 pt-0">
                <div>
                  <v-row>
                    <v-col class="mt-0 pt-0">
                      <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                          id="btn-down"
                          class="mt-2 pt-0 mb-2 d-md-none"
                          fab
                          dark
                          small
                          color="orange"
                          @click="$vuetify.goTo('#btn-up')"
                        >
                          <v-icon dark> mdi-chevron-down </v-icon>
                        </v-btn>
                      </div>
                      <div style="height: 80vh" class="d-flex align-stretch">
                        <embed
                          :src="review.ResumeUrl"
                          width="100%"
                          height="100%"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-divider class="d-md-none"></v-divider>
                <div>
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn
                      id="btn-up"
                      class="mt-2 pt-0 mb-2 d-md-none"
                      fab
                      dark
                      small
                      color="orange"
                      @click="$vuetify.goTo('#btn-down')"
                    >
                      <v-icon dark> mdi-chevron-up </v-icon>
                    </v-btn>
                  </div>

                  <!-- Visual rating - Standard + Full -->
                  <v-row
                    class="my-0 py-0"
                    v-if="review.Tier === 5 || review.Tier === 10"
                  >
                    <v-col cols="12" class="my-0 py-0">
                      <h4>Visual:</h4>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                      <div class="d-flex mb-1">
                        <v-rating
                          v-model="review.ScoreVisual"
                          background-color="blue"
                          color="blue"
                          half-increments
                          class="mx-auto"
                        >
                        </v-rating>
                      </div>
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                      <v-textarea
                        color="blue"
                        outlined
                        auto-grow
                        counter
                        :rules="commentRules"
                        v-model="review.CommentVisual"
                      >
                        <template v-slot:label>
                          <div>Comment the visual</div>
                        </template>
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-divider
                    v-if="review.Tier === 5 || review.Tier === 10"
                  ></v-divider>
                  <!-- Content rating - Standard + Full -->
                  <v-row
                    class="my-0 py-0 mt-3"
                    v-if="review.Tier === 5 || review.Tier === 10"
                  >
                    <v-col cols="12" class="my-0 py-0">
                      <h4>Content:</h4>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                      <div class="d-flex mb-1">
                        <v-rating
                          v-model="review.ScoreContent"
                          background-color="blue"
                          color="blue"
                          half-increments
                          class="mx-auto"
                        >
                        </v-rating>
                      </div>
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                      <v-textarea
                        color="blue"
                        outlined
                        auto-grow
                        :rules="commentRules"
                        v-model="review.CommentContent"
                      >
                        <template v-slot:label>
                          <div>Comment the content</div>
                        </template>
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-divider
                    v-if="review.Tier === 5 || review.Tier === 10"
                  ></v-divider>
                  <!-- Positive and criticism notes - ALL -->
                  <v-row>
                    <v-col cols="12" class="py-0 mt-5">
                      <h4>Notes</h4>
                      <v-subheader class="pa-0">
                        Feel free to write your own note or use the suggested
                        options
                      </v-subheader>
                    </v-col>
                    <v-col cols="12" class="mb-0 pb-0">
                      <v-combobox
                        v-model="review.NotesPositive"
                        :items="positiveNoteOptions"
                        chips
                        clearable
                        label="Positive note"
                        multiple
                        prepend-icon="mdi-plus"
                        :loading="notesLoading"
                      >
                        <template
                          v-slot:selection="{ attrs, item, select, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            :input-value="selected"
                            close
                            @click="select"
                            @click:close="remove(review.NotesPositive, item)"
                            color="#66BB6A"
                            text-color="white"
                          >
                            <strong>{{ item }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" class="mt-0 pt-0">
                      <v-combobox
                        v-model="review.NotesNegative"
                        :items="negativeNoteOptions"
                        chips
                        clearable
                        label="Criticism note"
                        multiple
                        prepend-icon="mdi-minus"
                        :loading="notesLoading"
                      >
                        <template
                          v-slot:selection="{ attrs, item, select, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            :input-value="selected"
                            close
                            @click="select"
                            @click:close="remove(review.NotesNegative, item)"
                            color="#FFA726"
                            text-color="white"
                          >
                            <strong>{{ item }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                  <!-- Overall rating - ALL -->
                  <v-row class="my-0 py-0 mt-5">
                    <v-col cols="12" class="my-0 py-0">
                      <h4>Overall rating:</h4>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                      <div class="d-flex">
                        <v-rating
                          v-model="review.ScoreOverall"
                          background-color="blue"
                          color="blue"
                          half-increments
                          class="mx-auto"
                          large
                        >
                        </v-rating>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="my-0 py-0">
                    <v-col class="my-0 py-0">
                      <v-btn
                        block
                        color="primary"
                        class="mt-2"
                        @click="saveReview"
                        :loading="btnSaveLoading"
                        :disabled="btnSubmitLoading"
                        plain
                      >
                        Save
                      </v-btn>
                    </v-col>
                    <v-col class="my-0 py-0">
                      <v-btn
                        block
                        color="primary"
                        class="mt-2"
                        @click="submitReview"
                        :loading="btnSubmitLoading"
                        :disabled="btnSaveLoading"
                      >
                        Submit
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <p
              class="text--disabled overline mb-0 pb-0"
              style="font-size: 0.6rem !important"
            >
              RevId: {{ review.Id }}
            </p>
          </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" color="green">
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
          </template>
        </v-snackbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      commentRules: [
        (value) => {
          if (value) {
            if (value.length > 1000) {
              return "Max 1000 characters";
            }
            if (value.length < 200) {
              return "Min 200 characters";
            }
          }
          return true;
        },
      ],
      btnSubmitLoading: false,
      btnSaveLoading: false,
      review: null,
      reviewLoadingError: "",
      reviewLoading: true,
      errorMsg: "",
      notesLoading: true,
      positiveNoteOptions: [],
      negativeNoteOptions: [],
      snackbar: false,
      snackbarText: "",
    };
  },
  async mounted() {
    this.$utils.visit(this);
    var revId = this.$route.query.id;
    if (revId) {
      console.log("revid:" + revId);
      await this.loadReview(revId);
      await this.loadNotes();
    }
  },
  methods: {
    async loadReview(revId) {
      try {
        this.reviewLoading = true;
        this.reviewLoadingError = "";
        var resp = await this.$utils.callBackendPost(this, "/rec/getReview", {
          reviewId: revId,
        });
        console.log("got review: " + JSON.stringify(resp));
        this.review = resp;
      } catch (error) {
        this.reviewLoadingError = error;
      } finally {
        this.reviewLoading = false;
      }
    },
    async abandonReview() {
      try {
        this.reviewLoading = true;
        if (
          !confirm(
            "Are you sure you want to abandon this review? It will be unassigned from you and will get back to the review queue."
          )
        ) {
          this.reviewLoading = false;
          return;
        }
        await this.$utils.callBackendPost(this, "/rec/unassignReview", {
          reviewId: this.review.Id,
        });
        this.$router.push({ path: "queue" });
      } catch (error) {
        this.reviewLoadingError = error;
      } finally {
        this.reviewLoading = false;
      }
    },
    async submitReview() {
      console.log("submitReview()");
      var revId = this.$route.query.id;
      this.btnSubmitLoading = true;
      this.errorMsg = "";
      try {
        if (!this.readyToSubmit()) {
          return;
        }
        await this.$utils.callBackendPost(this, "/rec/submitReview", {
          review: this.review,
        });
        this.$router.push({ path: "queue" });
      } catch (error) {
        console.log("submitReview error: " + error);
        this.errorMsg = error;
      } finally {
        this.btnSubmitLoading = false;
      }
    },
    async saveReview() {
      console.log("saveReview()");
      var revId = this.$route.query.id;
      this.btnSaveLoading = true;
      this.errorMsg = "";
      try {
        await this.$utils.callBackendPost(this, "/rec/saveReview", {
          review: this.review,
        });
        this.snackbar = true;
        this.snackbarText = "Review saved";
      } catch (error) {
        console.log("saveReview error: " + error);
        this.errorMsg = error;
      } finally {
        this.btnSaveLoading = false;
      }
    },
    readyToSubmit() {
      let errorList = [];
      if (this.review.ScoreOverall === 0) {
        errorList.push("no overall rating");
      }
      if (this.review.NotesPositive.length === 0) {
        errorList.push("no positive note");
      }
      if (this.review.NotesNegative.length === 0) {
        errorList.push("no negative note");
      }
      if (errorList.length > 0) {
        this.errorMsg = "Some stuff is missing: " + errorList.join(", ");
        return false;
      }
      return true;
    },
    async loadNotes() {
      this.notesLoading = true;
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/rec/getReviewNotesList",
          {}
        );
        console.log("got notes: " + JSON.stringify(resp));
        this.positiveNoteOptions = resp.positiveNotes;
        this.negativeNoteOptions = resp.negativeNotes;
      } catch (error) {
        this.$utils.reportFError(this, error.message);
      } finally {
        this.notesLoading = false;
      }
    },
    remove(collection, item) {
      collection.splice(collection.indexOf(item), 1);
    },
  },
};
</script>
